// automatically generated by the FlatBuffers compiler, do not modify

export enum ConnectionStatus {
  Connected = 0,
  Disconnected = 1,
  Heartbeat = 2
}
